import {GET_BALANCE} from "../actions/navbar";
const initialState = {
    get_balance_waiting : false,
    get_balance_success : {},
    get_balance_error :{},
}

export default function navbar(state = initialState, action){
    switch (action.type){
        case GET_BALANCE:
            return {
                ...state,
                get_balance_waiting : action.get_balance_waiting,
                get_balance_success : action.get_balance_response,
                get_balance_error : action.get_balance_error
            }
        default:
            return state;
    }
}
